import { useState, useEffect } from 'react';
/* eslint-disable */

import { Paper, Typography, Box, Button } from '@mui/material';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import SettingsIcon from '@mui/icons-material/Settings';
import BiometricDevices from 'views/Components/BiometricDevices/BiometricDevices';
import { handleCapture } from 'views/Components/BiometricDevices/BiometricCapture';
import { biometricDevicesApi } from 'utils/API/Merchant APIs/AepsApiCalls';
import fingerScan from 'assets/gif/Finger_print_scanning.gif';
import { useSelector } from 'react-redux';

export default function AuthenticationBox({
    onCapture,
    onStatusChange,
    tabIndex,
    disableScanButton = false,
    responseStatus,
    dailyAuthClose,
    aepsType,
    otp
}) {
    const [selectedDeviceName, setSelectedDeviceName] = useState('');
    const [showDeviceList, setShowDeviceList] = useState(false);
    const [isScanning, setIsScanning] = useState(false);
    const [authStatus, setAuthStatus] = useState('idle');
    const [location, setLocation] = useState({ latitude: '', longitude: '' });
    const isReset = useSelector((state) => state.reset.isReset);
    const [deviceList, setDeviceList] = useState([]);
    const [forceShowDevices, setForceShowDevices] = useState(false);

    useEffect(() => {
        const fetchDevices = async () => {
            try {
                const agentid = localStorage.getItem('user_id');
                const payload = { agentid };
                const response = await biometricDevicesApi(payload);
                if (response?.data?.status) {
                    const devices = response.data.data;
                    setDeviceList(devices);
                    const defaultDevice = devices.find((d) => d.default === true);
                    if (defaultDevice) {
                        setSelectedDeviceName(defaultDevice.deviceName);
                    }
                }
            } catch (error) {
                console.log(error);
            }
        };
        fetchDevices();
    }, [dailyAuthClose]);

    const handleDeviceSelect = (deviceName) => {
        setSelectedDeviceName(deviceName);
        setShowDeviceList(false);
    };

    const onCaptureSuccess = (data) => {
        setIsScanning(false);
        if (data && data !== false) {
            setAuthStatus('success');
            if (typeof onCapture === 'function') onCapture(data);
        } else {
            setAuthStatus('error');
        }
    };

    const handleFinalSubmit = () => {
        if (selectedDeviceName) {
            setIsScanning(true);
            setAuthStatus('scanning');
            handleCapture(selectedDeviceName, onCaptureSuccess, aepsType, otp);
        }
    };

    useEffect(() => {
        if (typeof onStatusChange === 'function') {
            onStatusChange(authStatus, location);
        }
    }, [authStatus, location, onStatusChange]);

    useEffect(() => {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                setLocation({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude
                });
            },
            (error) => {
                console.error(error);
            }
        );
    }, []);

    const handleRetry = () => {
        handleFinalSubmit();
    };

    const renderIcon = () => {
        switch (authStatus) {
            case 'scanning':
                return (
                    <Box>
                        <img src={fingerScan} alt="Scanning..." style={{ width: 60, height: 60 }} />
                    </Box>
                );
            case 'success':
                return <CheckCircleIcon sx={{ fontSize: 60, color: 'green' }} />;
            case 'error':
                return <ErrorIcon sx={{ fontSize: 60, color: 'red' }} />;
            default:
                return <FingerprintIcon sx={{ fontSize: 60, color: '#888' }} />;
        }
    };

    const renderMessage = () => {
        switch (authStatus) {
            case 'scanning':
                return 'Scanning fingerprint...';
            case 'success':
                return 'Authentication successful';
            case 'error':
                return 'Authentication failed. Try again.';
            default:
                return 'Place your finger on the device';
        }
    };

    useEffect(() => {
        setShowDeviceList(false);
        setForceShowDevices(true);
        setIsScanning(false);
        setAuthStatus('idle');

        if (typeof onStatusChange === 'function') {
            onStatusChange('idle', location);
        }
    }, [tabIndex, isReset]);

    return (
        <>
            <Paper elevation={3} sx={{ p: 3, textAlign: 'center' }}>
                <Typography variant="subtitle1" fontWeight="bold" mb={2}>
                    Authentication
                </Typography>

                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
                    <Box sx={{ textAlign: 'center' }}>
                        {renderIcon()}
                        <Typography mt={1}>{renderMessage()}</Typography>
                    </Box>
                </Box>

                {authStatus === 'error' || responseStatus === false ? (
                    <Button
                        variant="contained"
                        color="error"
                        onClick={handleRetry}
                        sx={{ mt: 2 }}
                        disabled={isScanning || disableScanButton}
                    >
                        Retry
                    </Button>
                ) : (
                    <>
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() => {
                                setForceShowDevices(true);
                                setShowDeviceList(true);
                            }}
                            sx={{ mt: 2, mr: 2 }}
                            disabled={isScanning || disableScanButton}
                            startIcon={<SettingsIcon />}
                        >
                            {'Change Device'}
                        </Button>
                        <Button
                            variant="outlined"
                            color="info"
                            onClick={handleFinalSubmit}
                            sx={{ mt: 2 }}
                            disabled={isScanning || disableScanButton}
                            endIcon={<FingerprintIcon />}
                        >
                            {'Capture'}
                        </Button>
                    </>
                )}

                {selectedDeviceName && (
                    <Typography variant="body2" mt={1}>
                        Selected Device: <strong>{selectedDeviceName}</strong>
                    </Typography>
                )}

                {showDeviceList && (
                    <Box mt={2}>
                        <BiometricDevices
                            onDeviceSelect={handleDeviceSelect}
                            service={'AEPS'}
                            forceShow={forceShowDevices}
                            selectedValue={selectedDeviceName}
                            deviceList={deviceList}
                            onClose={() => setShowDeviceList(false)}
                        />
                    </Box>
                )}
            </Paper>
        </>
    );
}
